import { useEffect, useState } from "react";

const getMatches = (query) => {
    if (typeof window === "undefined" || !window.matchMedia) {
        return false;
    }

    return window.matchMedia(query).matches;
};

export const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(() => getMatches(query));

    useEffect(() => {
        if (typeof window === "undefined" || !window.matchMedia) {
            return undefined;
        }

        const mediaQuery = window.matchMedia(query);
        const handleChange = (event) => {
            setMatches(event.matches);
        };

        setMatches(mediaQuery.matches);

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener("change", handleChange);
            return () => mediaQuery.removeEventListener("change", handleChange);
        }

        mediaQuery.addListener(handleChange);
        return () => mediaQuery.removeListener(handleChange);
    }, [query]);

    return matches;
};
